export var ImageDelta;
(function (ImageDelta) {
    /**
     * Type of delta event.
     */
    let type;
    (function (type) {
        type["IMAGE_DELTA"] = "image_delta";
    })(type = ImageDelta.type || (ImageDelta.type = {}));
    /**
     * Image alignment setting.
     */
    let alignment;
    (function (alignment) {
        alignment["LEFT"] = "left";
        alignment["CENTER"] = "center";
        alignment["RIGHT"] = "right";
    })(alignment = ImageDelta.alignment || (ImageDelta.alignment = {}));
})(ImageDelta || (ImageDelta = {}));
